




















































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Chapter extends Vue {
    @Prop()
    private libraryId !: number;

    private loading = false;

    private pagedData = [];
    private multipleSelection: any[] = [];

    private editFormVisible = false;
    private editForm: any = {};
    private fileList = [];
    private token = {
        "Authorization": "Bearer " + this.$store.state.token
    };

    created() {
        this.reload();
    }

    reload() {
        this.$apis.getChapters(this.libraryId)
            .then((res: any) => {
                this.pagedData = res.data;
            });
    }

    // 多选改变
    onSelectionChange(rows: any) {
        this.multipleSelection = rows;
    }

    // 试题
    onTopic(id: string) {
        this.$router.push({ path: "/exam/browse", query: { chapterId: id } });
    }

    // 单个删除和批量删除删除
    onDelete(id: number) {
        this.$confirm('此操作将删除选中的题库, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            
            var ids = id == null ? this.multipleSelection.map(item => item.id) : [id];
            this.$apis.delChapters(this.libraryId, { data: { ids: ids } })
                .then((res: any) => {
                    this.reload(); // 刷新列表
                    
                    this.$message({
                        type: 'success',
                        message: '删除成功!'
                    });
                });
        });
    }

    // 新增
    onAdd() {
        this.editForm = {
            name: "",
            libraryId: this.libraryId,
            sequence: 0
        }
        this.editFormVisible = true;
    }

    // 编辑
    onEdit(row: any) {
        this.editForm = {
            id: row.id,
            libraryId: this.libraryId,
            name: row.name,
            sequence: row.sequence
        }
        this.editFormVisible = true;
    }

    // 提交
    onFinish() {
        this.editFormVisible = false;
        

        if (typeof (this.editForm.id) == "undefined") {
            // 新增
            this.$apis.postChapter(this.editForm)
                .then((res: any) => {
                    this.reload(); // 刷新列表
                    
                    this.fileList = [];
                    this.$message({
                        type: 'success',
                        message: '提交成功!'
                    });
                });
        } else {
            // 编辑
            this.$apis.putChapter(this.editForm)
                .then((res: any) => {
                    this.reload(); // 刷新列表
                    
                    this.fileList = [];
                    this.$message({
                        type: 'success',
                        message: '修改成功!'
                    });
                });
        }
    }

    onChange(file: any, fileList: []) {
        this.fileList = fileList;
        if (this.editForm.name == "")
            this.editForm.name = file.name.substring(0, file.name.lastIndexOf("."));
    }

    onSucess(res: any) {
        if (res.isSuccess) {
            this.editForm.topics = res.data;

            this.$message({
                type: 'success',
                message: `已成功识别${this.editForm.topics.length}道试题`
            });
        }
    }
}
